import type { CmmdTaskStatus, CmmdTaskWorkflow } from "@cmmd-forge/contracts";

import {
  initialCreateStatusSelection,
  type ProjectTaskCreateStatusSelection,
} from "./projectTaskCreateOptions";
import type { ProjectTaskCreateTarget } from "./taskViewTypes";

export function resolveCreateStatusSelection(
  value: string | null,
  workflow: CmmdTaskWorkflow | null | undefined,
): ProjectTaskCreateStatusSelection {
  const stage = workflow?.stages.find((candidate) => candidate.id === value);
  if (stage != null) return { status: stage.category, workflowStageId: stage.id };
  return { status: (value ?? "todo") as CmmdTaskStatus, workflowStageId: null };
}

export function selectedCreateStatusValue(
  status: CmmdTaskStatus,
  workflowStageId: string | null,
): string {
  return workflowStageId ?? status;
}

export function resolvedCreateStatusSelection(
  override: ProjectTaskCreateStatusSelection | null,
  workflow: CmmdTaskWorkflow | null | undefined,
  target: ProjectTaskCreateTarget | null,
): ProjectTaskCreateStatusSelection {
  return override ?? initialCreateStatusSelection(workflow, target);
}

export function isTaskCreationDisabled(input: {
  readonly creating: boolean;
  readonly workflowLoading?: boolean;
  readonly workflowMutationBlocked?: boolean;
}): boolean {
  return (
    input.creating || (input.workflowLoading ?? false) || (input.workflowMutationBlocked ?? false)
  );
}
